var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Editable, withReact, Slate } from "slate-react";
import { createEditor, Node, } from "slate";
import { withHistory } from "slate-history";
import { css } from "@emotion/css";
import { withPlugins } from "../plugins/withPlugins";
import CustomElement from "./Custom/CustomElement";
import CustomLeaf from "./Custom/CustomLeaf";
import AnchorList from "./Anchor/AnchorList";
import Title from "./Title/Title";
import Toolbar1 from "./Toolbars/Toolbar1";
import Toolbar2 from "./Toolbars/Toolbar2";
import Toolbar3 from "./Toolbars/Toolbar3";
import UnsplashModal from "../util/UnsplashModal";
var HOTKEYS = {
    "mod+b": "bold",
    "mod+i": "italic",
    "mod+u": "underline",
    "mod+`": "code",
};
var LionEditor = function (props) {
    var renderElement = useCallback(function (props) { return _jsx(CustomElement, __assign({}, props)); }, []);
    var renderLeaf = useCallback(function (props) { return _jsx(CustomLeaf, __assign({}, props)); }, []);
    var editor = useMemo(function () {
        return withPlugins(withHistory(withReact(createEditor())));
    }, []);
    var _a = __read(useState(props.DefaultContent ? props.DefaultContent : []), 2), slateValue = _a[0], setSlateValue = _a[1];
    // TODO: unsplash區塊 start-----------------------------------
    var _b = __read(useState(1), 2), pageNum = _b[0], setPageNum = _b[1];
    var _c = __read(useState(""), 2), unsplashSearchValue = _c[0], setUnsplashSearchValue = _c[1];
    var _d = __read(useState([]), 2), selectUnsplashImage = _d[0], setSelectUnsplashImage = _d[1];
    var _e = __read(useState(false), 2), isUnsplash = _e[0], setIsUnsplash = _e[1];
    var _f = __read(useState([]), 2), unsplashData = _f[0], setunsplashData = _f[1];
    // 抓取圖庫照片api
    var unsplashApi = "https://api.unsplash.com/search/photos?query=".concat(unsplashSearchValue, "&per_page=20&page=").concat(pageNum, "&client_id=9X0tz1aIDBowBtwGmgk5Q7xzSJqAwWiISn9NTLfN-mg");
    //
    console.log("selectUnsplashImage: ", selectUnsplashImage);
    //
    function getNewImage() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, fetch(unsplashApi)
                        .then(function (res) { return res.json(); })
                        .then(function (data) {
                        // console.log("✨data", data);
                        setunsplashData(data);
                    })];
            });
        });
    }
    // 打api取得unsplash資料
    useEffect(function () {
        getNewImage();
    }, [isUnsplash, pageNum, unsplashSearchValue]);
    useEffect(function () {
        // console.log("selectUnsplashImage", selectUnsplashImage);
    }, [selectUnsplashImage]);
    // unsplash區塊 end-----------------------------------------------
    var _g = __read(useState(function () {
        var anchor = localStorage.getItem("anchor");
        if (anchor) {
            return JSON.parse(anchor);
        }
        return [];
    }), 2), anchorList = _g[0], setAnchorList = _g[1];
    // store the content after state change
    useEffect(function () {
        var timer = setTimeout(function () {
            props.onSaveContent(slateValue);
        }, 3000);
        return function () {
            clearInterval(timer);
        };
    }, [slateValue]);
    var addAnchorHandler = function (data) {
        console.log(data);
        setAnchorList(function (prev) { return __spreadArray(__spreadArray([], __read(prev), false), [data], false); });
        console.log("anchorList:", anchorList);
    };
    var removeAnchorHandler = function (anchorId) {
        console.log(anchorId);
        setAnchorList(function (prev) {
            return prev.filter(function (anchorData) { return anchorData.id !== anchorId; });
        });
        console.log("anchorList:", anchorList);
    };
    var updateAnchorList = function (editor) {
        var topNodes = editor.children;
        var nodeWithId = topNodes
            .filter(function (node) {
            return "id" in node;
        })
            .map(function (node, idx) {
            var name = Node.string(node);
            return {
                id: node.id,
                order: idx,
                name: name,
                type: node.type,
            };
        });
        setAnchorList(nodeWithId);
        var anchor = JSON.stringify(nodeWithId);
        localStorage.setItem("anchor", anchor);
    };
    console.log(slateValue);
    return (_jsxs(Slate, __assign({ editor: editor, 
        // value={initialValue}
        value: props.DefaultContent ? props.DefaultContent : [], onChange: function (value) {
            var isAstChange = editor.operations.some(function (op) { return op.type !== "set_selection"; });
            if (isAstChange) {
                var content = JSON.stringify(value);
                updateAnchorList(editor);
                localStorage.setItem("content", content);
                setSlateValue(value);
            }
        } }, { children: [_jsxs("div", __assign({ className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          position: relative;\n          z-index: 0;\n          margin: 0px auto;\n          padding-top: 100px;\n        "], ["\n          position: relative;\n          z-index: 0;\n          margin: 0px auto;\n          padding-top: 100px;\n        "]))) }, { children: [_jsx(Title, {}), _jsx(Toolbar1, {}), _jsx(Toolbar2, { callback: [addAnchorHandler, removeAnchorHandler] }), _jsx(Toolbar3, { setIsUnsplash: setIsUnsplash, isUnsplash: isUnsplash }), isUnsplash && (_jsx(UnsplashModal, { unsplashData: unsplashData, setIsUnsplash: setIsUnsplash, isUnsplash: isUnsplash, pageNum: pageNum, setPageNum: setPageNum, setUnsplashSearchValue: setUnsplashSearchValue, setSelectUnsplashImage: setSelectUnsplashImage, selectUnsplashImage: selectUnsplashImage })), _jsx("div", __assign({ className: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            width: 100%;\n            max-width: 740px;\n            margin: 0 auto;\n          "], ["\n            width: 100%;\n            max-width: 740px;\n            margin: 0 auto;\n          "]))) }, { children: _jsx(Editable, { renderElement: renderElement, renderLeaf: renderLeaf, placeholder: "\u958B\u59CB\u5BEB\u4F5C\u5427!", spellCheck: true, autoFocus: true }) }))] })), _jsx("div", __assign({ className: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          position: fixed;\n          top: 20%;\n          left: 16px;\n          transform: translateY(-50%);\n          z-index: 11;\n        "], ["\n          position: fixed;\n          top: 20%;\n          left: 16px;\n          transform: translateY(-50%);\n          z-index: 11;\n        "]))) }, { children: _jsx(AnchorList, { listData: anchorList }) }))] })));
};
export default LionEditor;
var templateObject_1, templateObject_2, templateObject_3;
